//------------------------------------------------------------------------------------

const filterVendorsByStation = (mainArray) => {
    let employeeStation = JSON.parse(localStorage.getItem('employee')).station;
    let employeeDesignation = JSON.parse(localStorage.getItem('employee')).designation;
    let allVendors = [...mainArray];
    let copyArray = [];

    if (employeeDesignation == 'CCI') {
        if (
            employeeStation == 'Bhusawal-Jn' ||
            employeeStation == 'Jalgaon-Jn' ||
            employeeStation == 'Malkapur' ||
            employeeStation == 'Nandura'
        ) {
            for (let vendor of allVendors) {
                if (
                    vendor.station == 'Bhusawal-Jn' ||
                    vendor.station == 'Jalgaon-Jn' ||
                    vendor.station == 'Malkapur' ||
                    vendor.station == 'Nandura'
                ) {
                    copyArray.push(vendor);
                }
            }
        }
        else if (
            employeeStation == 'Akola-Jn' ||
            employeeStation == 'Shegaon'
        ) {
            for (let vendor of allVendors) {
                if (
                    vendor.station == 'Akola-Jn' ||
                    vendor.station == 'Shegaon'
                ) {
                    copyArray.push(vendor);
                }
            }
        }
        else if (
            employeeStation == 'Nashik Road' ||
            employeeStation == 'Niphad' ||
            employeeStation == 'Devlali'
        ) {
            for (let vendor of allVendors) {
                if (
                    vendor.station == 'Nashik Road' ||
                    vendor.station == 'Niphad' ||
                    vendor.station == 'Devlali'
                ) {
                    copyArray.push(vendor);
                }
            }
        }
        else if (
            employeeStation == 'Manmad-Jn' ||
            employeeStation == 'Nandgaon' ||
            employeeStation == 'Lasalgaon'
        ) {
            for (let vendor of allVendors) {
                if (
                    vendor.station == 'Manmad-Jn' ||
                    vendor.station == 'Nandgaon' ||
                    vendor.station == 'Lasalgaon'
                ) {
                    copyArray.push(vendor);
                }
            }
        }
        else if (
            employeeStation == 'Khandwa' ||
            employeeStation == 'Burhanpur' ||
            employeeStation == 'Nepanagar' ||
            employeeStation == 'Raver'
        ) {
            for (let vendor of allVendors) {
                if (
                    vendor.station == 'Burhanpur' ||
                    vendor.station == 'Khandwa' ||
                    vendor.station == 'Nepanagar' ||
                    vendor.station == 'Raver'
                ) {
                    copyArray.push(vendor);
                }
            }
        }
        else if (
            employeeStation == 'Badnera-Jn' ||
            employeeStation == 'Murtizapur' ||
            employeeStation == 'Amravati'
        ) {
            for (let vendor of allVendors) {
                if (
                    vendor.station == 'Badnera-Jn' ||
                    vendor.station == 'Murtizapur' ||
                    vendor.station == 'Amravati'
                ) {
                    copyArray.push(vendor);
                }
            }
        }
        else if (
            employeeStation == 'Chalisgaon-Jn' ||
            employeeStation == 'Pachora-Jn' ||
            employeeStation == 'Dhule'
        ) {
            for (let vendor of allVendors) {
                if (
                    vendor.station == 'Chalisgaon-Jn' ||
                    vendor.station == 'Pachora-Jn' ||
                    vendor.station == 'Dhule'
                ) {
                    copyArray.push(vendor);
                }
            }
        }
        else {
            for (let vendor of allVendors) {
                if (vendor.station == employeeStation) {
                    copyArray.push(vendor);
                }
            }
        }
    } else {
        for (let vendor of allVendors) {
            if (vendor.station == employeeStation) {
                copyArray.push(vendor);
            }
        }
    }
    return copyArray;
}

export default filterVendorsByStation;

//------------------------------------------------------------------------------------
